<template>
  <v-card flat>
    <v-container>
      <div class="">
        <h3 class="earth-color">ADD ACCOMMODATION DISCOUNT</h3>
      </div>
      <div class="row">
        <div class="col-md-12">
          <v-form @submit.prevent="addDiscount()">
            <v-layout row wrap>
              <v-flex lg3 md3 sm12 xs12>
                <v-container fluid>
                  <v-autocomplete
                    label="Partner Types"
                    v-model="discount.discount_type_id"
                    :items="allPartnerTypes"
                    :rules="[v => !!v || 'Partner Type is required']"
                    required
                    item-text="name"
                    item-value="public_id"
                    @change="populatePartnerInfo"
                    :loading="$loadingTrue"
                  ></v-autocomplete>
                </v-container>
              </v-flex>
              <v-flex lg3 md3 sm12 xs12>
                <v-container>
                  <v-text-field
                    label="Discount (%)"
                    v-model="discount.discount"
                    :rules="requiredRules"
                    required
                    type="number"
                  ></v-text-field>
                </v-container>
              </v-flex>
              <v-flex lg3 md3 sm12 xs12>
                <v-container>
                  <v-text-field
                    label=" Agents  Discount (%)"
                    v-model="discount.commission"
                    :rules="requiredRules"
                    required
                    type="number"
                  ></v-text-field>
                </v-container>
              </v-flex>
              <v-flex lg3 md3 sm12 xs12>
                <v-container fluid>
                  <v-btn :depressed="true" block color="primary" type="submit"
                    >Add</v-btn
                  >
                </v-container>
              </v-flex>
            </v-layout>
          </v-form>
        </div>
        <div class="col-md-12">
          <table cellpadding="1" cellspacing="1" class="table table-bordered">
            <thead>
              <tr>
                <td>Created Date</td>
                <td>Name</td>
                <td>Discount</td>
                <td>Agents Discount</td>
                <td>Action</td>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(d, key) in allFacilityDiscounts" :key="key">
                <td>{{ formated_date(d.created_at) }}</td>
                <td>{{ d.name }}</td>
                <td>{{ d.discount }}%</td>
                <td>{{ d.commission }}%</td>
                <td>
                  <v-btn
                    :depressed="true"
                    color="error"
                    small
                    @click="disableDiscount(d.public_id)"
                    >Disable</v-btn
                  >
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </v-container>
  </v-card>
</template>

<script>
export default {
  name: "facility-discount",
  data() {
    return {
      requiredRules: [v => !!v || "This field is required"],
      discount: {
        discount_type_id: "",
        name:"",
        commission: 0,
        discount: 0,
        facility_id: this.$route.params.facility_id,
        session_id: localStorage.getItem("lkjhgfdsa")
      }
    };
  },
  created() {
    this.$store.dispatch(
      "get_facility_discounts",
      this.$route.params.facility_id
    );
    this.$store.dispatch("get_all_partner_types");
  },
  methods: {
    disableDiscount: function(publicId) {
      var data = {
        facility_id: this.$route.params.facility_id,
        public_id: publicId,
        deleted_by: localStorage.getItem("lkjhgfdsa")
      };
      this.$store.dispatch("delete_facility_discount", data);
    },
    populatePartnerInfo: function(publicId) {
      let partnerArr = this.$store.state.PartnerTypeStore.all_partner_types
      let partnerObj = partnerArr.filter(partner => partner.public_id === publicId);
      this.discount.name = partnerObj[0].name
     
    },
    addDiscount: function() {
      var instance = this;
      var data =  instance.discount
      this.$store.dispatch("post_facility_discount", data).then(function() {
        instance.discount.discount_type_id = "";
        instance.discount.commission = 0;
        instance.discount.discount = 0;
      });
    }
  }
};
</script>

<style scoped></style>
